import React from 'react';
import './header.css';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Select,
  MenuItem,
  FormControl,
  Grid,
  Paper,
  Chip,
  useTheme,
  alpha
} from '@mui/material';

const Header = () => {
  return (<>
  <Typography 
            variant="h4" 
            sx={{ 
              fontWeight: 700,
              color: 'black',
              textAlign: 'left',
              mb: 1,
              
            }}
          >
           Welcome To The Dashboard
          </Typography>

     <Typography 
              variant="subtitle1" 
              sx={{ 
                color: 'black',
                textAlign: 'left'
              }}
            >
               Here's what's happening with your inspections today.
            </Typography>
    
    </>
  );
};

export default Header;